import { styled, TableCell } from '@mui/material'

const ActionTableCell = styled(TableCell)({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  width: '1px',
  textAlign: 'right',
})

export default ActionTableCell
